
function getNestedValue(obj: Record<string, unknown>, path: string): string {
  const value = path.split(".").reduce<unknown>((acc, key) => {
    if (acc && typeof acc === "object" && key in acc) {
      return (acc as Record<string, unknown>)[key];
    }
    return undefined;
  }, obj);
  return typeof value === "string" ? value : path;
}

export function resolveSearchLabel(t: Translations, labelKey: string): string {
  return getNestedValue(t as unknown as Record<string, unknown>, labelKey);
}

export function filterSearchItems(
  items: SearchItem[],
  query: string,
  t: Translations
): SearchItem[] {
  const q = query.trim().toLowerCase();
  if (!q) return items.slice(0, 8);

  return items.filter((item) => {
    const label = resolveSearchLabel(t, item.labelKey).toLowerCase();
    return (
      label.includes(q) ||
      item.keywords.some((kw) => kw.toLowerCase().includes(q))
    );
  });
}
